import { apiFetch } from '../apilib/api-base.js';
import { errorFromResponse } from './api-connection-error.js';
import { createKeycloakIdentityProvider } from '../identity-provider/keycloak-identity-provider.js';
import { BeeyIdentityProvider } from '../identity-provider/beey-identity-provider.js';
import { Result } from 'monadix/result';
export class ApiConnection {
    constructor(identityProvider, beeyVersion) {
        this.retrieveAuthString = async () => {
            return this.identityProvider.retrieveAuthString();
        };
        this.getOutdatedAuthString = () => {
            return this.identityProvider.getOutdatedAuthString();
        };
        this.identityProvider = identityProvider;
        this.beeyVersion = beeyVersion;
    }
    static async fromAuthString(authString, beeyVersion) {
        if (authString.startsWith('Apa-Bearer ')) {
            const keycloak = await createKeycloakIdentityProvider();
            return new ApiConnection(keycloak, beeyVersion);
        }
        return new ApiConnection(new BeeyIdentityProvider(authString), beeyVersion);
    }
    async close() {
        var _a;
        await this.cleanup();
        (_a = this.closeHandler) === null || _a === void 0 ? void 0 : _a.call(this, 'explicit');
    }
    on(event, handler) {
        switch (event) {
            case 'version-mismatch':
                this.versionMismatchHandler = handler;
                break;
            case 'close':
                this.closeHandler = handler;
                break;
            default:
                event;
                throw new Error('ASSERT: This should never happen');
        }
    }
    authFetch() {
        var _a;
        return apiFetch()
            .version((_a = this.beeyVersion) !== null && _a !== void 0 ? _a : null)
            .config({ throwOnHttpError: true })
            .auth(async () => this.retrieveAuthString())
            .intercept(async (response) => {
            var _a;
            if (response.status === 401) {
                await this.closeAfterAuthFail();
                throw await errorFromResponse(response);
            }
            if (response.versionMatch !== 'perfect') {
                (_a = this.versionMismatchHandler) === null || _a === void 0 ? void 0 : _a.call(this, response.versionMatch);
                if (response.versionMatch === 'incompatible') {
                    throw new Error('incompatible api version');
                }
            }
            return Result.success(response);
        });
    }
    async cleanup() {
        await this.identityProvider.logOut();
    }
    async closeAfterAuthFail() {
        var _a;
        await this.cleanup();
        (_a = this.closeHandler) === null || _a === void 0 ? void 0 : _a.call(this, 'auth-fail');
    }
}
